/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';

xplenty.directive('googleAdsDestinationEditor', [
  '$timeout',
  '$rootScope',
  '$translate',
  function ($timeout, $rootScope, $translate) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./google-ads-destination-editor.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        function ($scope) {
          $scope.schemas = [];
          $scope.idOptions = [];
          $scope.schemaReady = false;
          $scope.areFieldsLoading = false;
          $scope.schemaMappingStep.lock = true;
          $scope.records = angular.copy($scope.component.column_mappings);

          $scope.operationTypes = [
            {
              value: 'insert',
              text: 'google-ads-destination-editor.form.operation-type.option.insert',
              translate: true,
            },
          ];

          $scope.onColumnMappingsChange = (records) => {
            $scope.component.column_mappings = records;
          };

          $scope.onSchemaValidityChange = (isValid) => {
            $scope.collectionValid = isValid;

            const schemaMappingValid = $scope.collectionValid && !$scope.loadingFields;

            if (schemaMappingValid) {
              $scope.schemaMappingStep.tags = _.map($scope.records, function (record) {
                return {
                  name: _.escape(record.column_name),
                };
              });
            } else {
              $scope.schemaMappingStep.tags = [];
            }

            $scope.schemaMappingStep.error = !$scope.collectionValid;
            $scope.schemaMappingStep.valid = schemaMappingValid;

            return schemaMappingValid;
          };

          $scope.onOperationTypeChange = (operationType) => {
            $scope.component.operation_type = operationType;
          };

          $scope.onIdFieldChange = (idField) => {
            $scope.component.id_field = idField;
            $scope.idFieldErrorMsg = null;
          };

          $scope.$on(EVENTS.GOOGLE_ADS_OBJECT_PICKER_FIELDS_LOAD_START, function () {
            $scope.schemaReady = false;
            $scope.schemaMappingStep.loading = true;
            $scope.schemaMappingStep.lock = false;
            $scope.areFieldsLoading = true;
          });

          $scope.$on(EVENTS.GOOGLE_ADS_OBJECT_PICKER_FIELDS_LOADED, function (event, fields) {
            const destinationSchema = {};

            destinationSchema.id = 'google_ads_fields';
            destinationSchema.name = 'google_ads_fields';
            destinationSchema.fields = [];
            $scope.idOptions = [];
            _.each(fields, (field) => {
              destinationSchema.fields.push({
                name: field.name,
              });
              $scope.idOptions.push({ text: field.name, value: field.name });
            });

            const schemas = [$scope.parentSchemas[0], destinationSchema];

            $scope.schemas = schemas;
            $scope.fields = fields;

            $scope.schemaReady = true;
            $scope.schemaMappingStep.lock = false;
            $scope.schemaMappingStep.loading = false;

            $scope.areFieldsLoading = false;
          });
        },
      ],
    };
  },
]);
